import { PRIVACY_NOTICE, SAAS_SERVICES_AGREEMENT } from '@/constants/routes';
import { FRONT_LEGAL_NAME } from '@/constants/strings';
import { Text } from '../_rebrand/Text';

const TermsAndPrivacyNotice = () => {
  return (
    <Text as="p" type="caption2" className="text-primary">
      By clicking &ldquo;Continue&rdquo;, I acknowledge I have read and agreed to{' '}
      {FRONT_LEGAL_NAME}&rsquo;s{' '}
      <a href={SAAS_SERVICES_AGREEMENT} target="_blank" rel="noreferrer" className="underline">
        Terms
      </a>{' '}
      and{' '}
      <a href={PRIVACY_NOTICE} target="_blank" rel="noreferrer" className="underline">
        Privacy Notice
      </a>
      .
    </Text>
  );
};

export default TermsAndPrivacyNotice;
